import { t } from '@framework/i18n/intl/i18next.ts';

/**
 * Avviso neutro mostrato all'utente quando un'area disegnata non produce
 * competenza (codice mancante o non risolto). Il dettaglio tecnico è loggato
 * a parte dal chiamante. key stabile: riusando la stessa key il toast si
 * aggiorna invece di accumularsi quando il calcolo riesegue.
 *
 * Risolve la traduzione a ogni chiamata tramite il `t` globale: viene invocato
 * da listener registrati una sola volta, quindi seguirebbe lo switch lingua a
 * runtime solo leggendo la label al momento del toast.
 */
export function getCompetenceNotAttributedWarning() {
  return {
    key: 'map-competence-not-attributed',
    content: t(
      'map-widget.competence-not-attributed-warning',
      'Non è stato possibile attribuire automaticamente la competenza per una o più aree selezionate.',
    ),
  };
}
